module.exports = __webpack_public_path__ + "static/media/cropping_02.56bf3564.png";